import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEnquiryModal } from "./EnquiryModal";
import "../App.css";
import { ENQUIRY_CTA } from "../constants";

const villas = [
  {
    id: 1,
    title: "3 Bedroom Elea",
    // description: "5 & 6 Bedroom Villas",
    size: "2,444 Sqft",
    price: "From: 2.9 M AED",
    img: "../Assets/gallery8.jpg",
  },
  {
    id: 2,
    title: "4 Bedroom Elea",
    // description: "5 & 6 Bedroom Villas",
    size: "2,837 Sqft",
    price: "From: 3.9 M AED",
    img: "../Assets/gallery7.jpg",
  },
  {
    id: 3,
    title: "4 Bedroom Rivera",
    // description: "5 & 6 Bedroom Villas",
    size: "3,688 Sqft",
    price: "From: 4.8 M AED",
    img: "../Assets/gallery6.jpg",
  },
  {
    id: 4,
    title: "4 Bedroom Ovelle",
    // description: "5 & 6 Bedroom Villas",
    size: "4,345 Sqft",
    price: "From: 7.09 M AED",
    img: "../Assets/gallery10.jpg",
  },
  {
    id: 5,
    title: "5 Bedroom Ovelle",
    // description: "5 to 7 Bedroom Villas",
    size: "5,654 Sqft",
    price: "From 8.85 M AED",
    img: "../Assets/gallery9.jpg",
  },
  {
    id: 6,
    title: "4 Bedroom Avelia",
    // description: "5 to 7 Bedroom Villas",
    size: "4,346 Sqft",
    price: "From 7.25 M AED",
    img: "../Assets/gallery11.jpg",
  },
  {
    id: 7,
    title: "5 Bedroom Avelia",
    // description: "5 to 7 Bedroom Villas",
    size: "5,655 Sqft",
    price: "From 8.86 M AED",
    img: "../Assets/gallery12.jpg",
  },
];

const PriceSection = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="price" className="bg-[#0d1b2a] py-10 pb-24">
      <h2 className="text-center text-[#997736] text-2xl font-bold mb-8">
        Price Overview
      </h2>

      {/* Desktop View - Grid */}
      <div className="hidden md:block max-w-6xl mx-auto px-4">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation
        >
          {villas.map((villa) => (
            <SwiperSlide key={villa.id}>
              <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <img
                  src={villa.img}
                  alt={villa.title}
                  className="w-full h-72 object-cover hover:scale-110 transition-transform duration-300"
                />
                <div className="p-6 text-center">
                  <h3 className="text-[#997736] font-bold text-lg mb-2">
                    {villa.title}
                  </h3>
                  <p className="text-gray-600">{villa.size}</p>
                  <p className="text-gray-800 font-semibold">{villa.price}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Mobile View - Carousel */}
      <div className="md:hidden px-4 overflow-hidden">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
        >
          {villas.map((villa) => (
            <SwiperSlide key={villa.id}>
              <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <img
                  src={villa.img}
                  alt={villa.title}
                  className="w-full h-72 object-cover hover:scale-110 transition-transform duration-300"
                />
                <div className="p-6 text-center">
                  <h3 className="text-[#997736] font-bold text-lg mb-2">
                    {villa.title}
                  </h3>
                  {/* <p className="text-gray-600">{villa.description}</p> */}
                  <p className="text-gray-600">{villa.size}</p>
                  <p className="text-gray-800 font-semibold">{villa.price}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Center Button */}
      <div className="flex justify-center mt-10">
        <button onClick={() => openModal(ENQUIRY_CTA.PRICING)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">
          Browse Emaar Rivera Valley Townhouses & Villas
        </button>
      </div>
    </div>
  );
};

export default PriceSection;
